import { lazy, useEffect, useState } from 'react';
// layout
import MainLayout from '../layouts/app-layout/MainLayout';

// sample routing
const Page404 = lazy(() => import('../views/common-views/404-page'));
const Home = lazy(() => import('../views/app-views/home/container'));
const LoginContainer = lazy(
  () => import('../views/app-views/home/container/loginContainer')
);

const Router = {
  path: '/',
  // element: <LayoutWrapper />,
  children: [
    {
      path: '/*',
      element: <Page404 />,
    },
    {
      path: '/',
      element: (
        <MainLayout>
          <Home />
        </MainLayout>
      ),
    },
    {
      path: '/generate-link',
      element: (
        <MainLayout>
          <Home />
        </MainLayout>
      ),
    },
    {
      path: '/customer/:uuid',
      element: (
        <MainLayout>
          <Home />
        </MainLayout>
      ),
    },
    {
      path: '/login',
      element: (
        <MainLayout>
          <LoginContainer />
        </MainLayout>
      ),
    },
  ],
};

export default Router;
